import React from 'react';
import { chevrons } from '../../../svg/SVGData';
import { Link } from 'react-router';
import { motion, useMotionValue } from 'motion/react';
import { animate } from 'motion';

const PipsReturn = () => {
    const scale = useMotionValue(1);

    return (
        <Link to='/'>
            <motion.div
                className='h-full p-2 hover:cursor-pointer'
                onHoverStart={() => animate(scale, 1.1)}
                onHoverEnd={() => animate(scale, 1)}
            >
                <motion.svg
                    className='h-full'
                    style={{ scale }}
                    viewBox={chevrons['left'].viewbox}
                >
                    <path
                        d={chevrons['left'].path}
                        fill='black'
                        stroke='black'
                        strokeWidth={1}
                    />
                </motion.svg>
            </motion.div>
        </Link>
    )
}

export default PipsReturn;